var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "oferta h-screen fixed pin-t pin-l w-full justify-center items-center p-4 md:p-8 lg:p-16 bg-white",
      class: {
        hidden: !_vm.isOpen,
        flex: _vm.isOpen
      }
    },
    [
      _c("div", { staticClass: "relative" }, [
        _c(
          "svg",
          {
            staticClass:
              "absolute pin-tr-50 block w-6 h-6 text-black hover:text-gold fill-current cursor-pointer",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 21.9 21.9"
            },
            on: { click: _vm.close }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M14.1 11.3c-.2-.2-.2-.5 0-.7l7.5-7.5c.2-.2.3-.5.3-.7s-.1-.5-.3-.7L20.2.3c-.2-.2-.5-.3-.7-.3-.3 0-.5.1-.7.3l-7.5 7.5c-.2.2-.5.2-.7 0L3.1.3C2.9.1 2.6 0 2.4 0s-.5.1-.7.3L.3 1.7c-.2.2-.3.5-.3.7s.1.5.3.7l7.5 7.5c.2.2.2.5 0 .7L.3 18.8c-.2.2-.3.5-.3.7s.1.5.3.7l1.4 1.4c.2.2.5.3.7.3s.5-.1.7-.3l7.5-7.5c.2-.2.5-.2.7 0l7.5 7.5c.2.2.5.3.7.3s.5-.1.7-.3l1.4-1.4c.2-.2.3-.5.3-.7s-.1-.5-.3-.7l-7.5-7.5z"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step === 1,
                expression: "step === 1"
              }
            ],
            staticClass: "text-center"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold uppercase"
              },
              [_vm._v("Profita de Super Oferta")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mb-4 md:mb-8" }, [
              _vm._v("Obtine cele mai mici preturi din Romania.")
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v("Solicita oferta acum si primesti un cupon de:")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "mb-4 md:mb-8 text-gold text-3xl sm:text-4xl md:text-5xl font-bold uppercase"
              },
              [_vm._v("-10% reducere")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "w-full lg:w-auto px-8 py-3 border border-gold bg-gold hover:bg-transparent text-white hover:text-gold text-center uppercase focus:outline-none",
                on: {
                  click: function($event) {
                    _vm.step = 2
                  }
                }
              },
              [_vm._v("Da, vreau reducerea")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step === 2,
                expression: "step === 2"
              }
            ],
            staticClass: "max-w-sm"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "mb-4 md:mb-8 text-2xl sm:text-3xl md:text-4xl text-center font-bold uppercase"
              },
              [_vm._v("Persoana juridica")]
            ),
            _vm._v(" "),
            Object.keys(_vm.errors).length > 0
              ? _c(
                  "ul",
                  { staticClass: "mb-8 text-red" },
                  _vm._l(_vm.errors, function(error, index) {
                    return _c("li", { key: index }, [_vm._v(_vm._s(error))])
                  })
                )
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.name,
                  expression: "name"
                }
              ],
              staticClass:
                "w-full mb-6 border-b border-gold focus:border-black leading-loose focus:outline-none",
              attrs: { type: "text", placeholder: "Nume firma*" },
              domProps: { value: _vm.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.name = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.city,
                  expression: "city"
                }
              ],
              staticClass:
                "w-full mb-6 border-b border-gold focus:border-black leading-loose focus:outline-none",
              attrs: { type: "text", placeholder: "Localitate*" },
              domProps: { value: _vm.city },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.city = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.phone,
                  expression: "phone"
                }
              ],
              staticClass:
                "w-full mb-6 border-b border-gold focus:border-black leading-loose focus:outline-none",
              attrs: { type: "tel", placeholder: "Telefon*" },
              domProps: { value: _vm.phone },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.phone = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              staticClass:
                "w-full mb-6 border-b border-gold focus:border-black leading-loose focus:outline-none",
              attrs: { type: "email", placeholder: "Email*" },
              domProps: { value: _vm.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("label", { staticClass: "block w-full mb-6 pointer" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.marketing,
                    expression: "marketing"
                  }
                ],
                staticClass: "mr-2 align-top",
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.marketing)
                    ? _vm._i(_vm.marketing, null) > -1
                    : _vm.marketing
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.marketing,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.marketing = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.marketing = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.marketing = $$c
                    }
                  }
                }
              }),
              _vm._v(
                "\n\n        Prin bifarea acestei căsuțe am citit și sunt de acord cu Termenele și Condițiile TopGranit.\n      "
              )
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "w-full px-8 py-3 border border-gold bg-gold text-white text-center uppercase focus:outline-none",
                class: {
                  "hover:bg-transparent hover:text-gold": _vm.ready,
                  "opacity-50 cursor-not-allowed": !_vm.ready
                },
                attrs: { disabled: !_vm.ready },
                on: { click: _vm.send }
              },
              [_vm._v("Vreau oferta")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step === 3,
                expression: "step === 3"
              }
            ],
            staticClass: "max-w-sm text-center"
          },
          [
            _c(
              "svg",
              {
                staticClass: "w-12 h-12 mb-6 text-gold fill-current",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 44 44"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M22 0C9.8 0 0 9.8 0 22s9.8 22 22 22 22-9.8 22-22S34.2 0 22 0zm12.7 15.1l-16 16.6c-.2.2-.4.3-.7.3-.3 0-.6-.1-.7-.3l-7.8-8.4-.2-.2c-.2-.2-.3-.5-.3-.7s.1-.5.3-.7l1.4-1.4c.4-.4 1-.4 1.4 0l.1.1 5.5 5.9c.2.2.5.2.7 0l13.4-13.9h.1c.4-.4 1-.4 1.4 0l1.4 1.4c.4.3.4.9 0 1.3z"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "mb-4 text-2xl sm:text-3xl md:text-4xl font-bold uppercase"
              },
              [_vm._v("Multumim!")]
            ),
            _vm._v(" "),
            _c("div", [
              _vm._v("Va vom contacta in cel mai scurt timp posibil.")
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-6" }, [
      _c("p", { staticClass: "mb-2" }, [
        _c("b", [_vm._v("Termene și Condiții:")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-2" }, [
        _vm._v(
          "Sunt de acord ca datele mele cu caracter personal să fie prelucrate de TopGranit în scopul:"
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "informării în ceea ce privește noile produse, servicii sau oferte care prezintă interes pentru mine"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "contactării sub formă de e-mail sau la telefon pentru stabilirea termenilor colaborării"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d0fe630", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/arthurkirkosa/sites/topgranit/wp-content/themes/topgranit/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d0fe630","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!/Users/arthurkirkosa/sites/topgranit/wp-content/themes/topgranit/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/SuperOferta.vue
// module id = 51
// module chunks = 0